import {AppTrackingStatusResponse, AppTrackingTransparency} from 'capacitor-plugin-app-tracking-transparency';
import {Injectable} from "@angular/core";
import {Capacitor} from "@capacitor/core";

/**
 * This service is used to request the tracking permission to the user.
 * Only available on iOS.
 */
export abstract class AppTrackingTransparencyService {
    /**
     * Requests the tracking permission to the user and returns true if the user has accepted it.
     */
    public abstract requestTrackingPermission(): Promise<boolean>;
}
@Injectable()
export class CapacitorAppTrackingTransparencyService implements AppTrackingTransparencyService {
    public async requestTrackingPermission(): Promise<boolean> {
        if (Capacitor.getPlatform() !== 'ios') {
            return true;
        }
        const response: AppTrackingStatusResponse = await AppTrackingTransparency.requestPermission();
        return response.status === 'authorized';
    }
}
